import axios from 'axios'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
export const mapperHelperService = async (data) => {
  try {
    let url = `${process.env.REACT_APP_URL_REDMINE}/mapper`
    const res = await axios.post(url, {
      body: data,
    })
    return res.data
  } catch (error) {
    IsAuthorized(error)
    throw error
  }
}
